// import { useEffect } from "react";

// const RedirectToExternal = ({ path }) => {
//     useEffect(() => {
//         window.location.href = path;
//     }, [path]);

//     return null;
// };

// export default RedirectToExternal;

import { useContext, useEffect, useState } from "react";
import styles from "./styles/RedirectToExternal.module.css";
import DataContext from "../../../context/DataContext";

const RedirectToExternal = ({ path }) => {
    const { setIsRedirecting } = useContext(DataContext);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsRedirecting(true);
        // Use replace instead of setting href
        window.location.replace(path);

        // Set a timeout to handle cases where the redirect doesn't happen immediately
        const timeoutId = setTimeout(() => {
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [path]);

    if (isLoading) {
        return (
            <div
                className={`${styles.redirect_background} flex-container`}
            ></div>
        );
    }

    return null;
};

export default RedirectToExternal;
